import { render, staticRenderFns } from "./CreateVehicleForm.vue?vue&type=template&id=93902468&"
import script from "./CreateVehicleForm.vue?vue&type=script&lang=js&"
export * from "./CreateVehicleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports